import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { RouteRestrictionBoundary } from "@app/authorization";
import { Forbidden, NotFound, Unauthorized } from "@app/shared/ErrorPages";
import { UserContext } from "@app/user";
import { ManageAccount } from "@app/user/account/ManageAccount";
import { JSX } from "react";

/** Renders the routing components for the account sub-section of the app. */
export default function AccountRouter(props: RouteComponentProps): JSX.Element {
  return (
    <UserContext.Consumer>
      {(user) => (
        user
          ? (
            <RouteRestrictionBoundary user={user} {...props}>
              <Switch>
                <Route
                  path={`${props.match.path}/manage`}
                  render={(renderProps) => user.isPrimaryAccount ? <ManageAccount user={user} {...renderProps} /> : <Forbidden />}
                />

                <Route
                  component={NotFound}
                />
              </Switch>
            </RouteRestrictionBoundary>
          )
          : (<Unauthorized />)
      )}
    </UserContext.Consumer>
  );
}
